"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ = require("../");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Position = exports["default"] = /*#__PURE__*/function () {
  function Position() {
    _classCallCheck(this, Position);
    _defineProperty(this, "type", "static");
    //[static,relative]
    _defineProperty(this, "relativePosition", null);
    _defineProperty(this, "target", {
      element: null,
      position: {}
    });
    _defineProperty(this, "content", {
      element: null,
      position: {}
    });
    _defineProperty(this, "offsetParent", {});
    _defineProperty(this, "window", window);
    _defineProperty(this, "IsDeviceIOS", _.utilities.device.IsDeviceIOS);
  }
  return _createClass(Position, [{
    key: "setType",
    value: function setType(type) {
      this.type = type;
    }
  }, {
    key: "setContent",
    value: function setContent(content) {
      this.content.element = content;
    }
  }, {
    key: "setTarget",
    value: function setTarget(target) {
      this.target.element = target;
    }
  }, {
    key: "setRelativePosition",
    value: function setRelativePosition(position) {
      this.relativePosition = position;
    }
  }, {
    key: "getNodeBox",
    value: function getNodeBox(target) {
      try {
        return target.getBoundingClientRect();
      } catch (e) {}
    }
  }, {
    key: "correctEdgeValues",
    value: function correctEdgeValues(box) {
      if (!box) {
        return {};
      }

      /* istanbul ignore else */
      if (!box.x && box.left) {
        box.x = box.left;
        box.y = box.top;
      }
      return box;
    }
  }, {
    key: "getTargetBox",
    value: function getTargetBox() {
      this.offsetParent = this.correctEdgeValues(this.getNodeBox(this.target.element.current.offsetParent));
      this.target.position = this.correctEdgeValues(this.getNodeBox(this.target.element.current));
    }
  }, {
    key: "getContentBox",
    value: function getContentBox() {
      this.content.position = this.correctEdgeValues(this.getNodeBox(this.content.element.current));
    }
  }, {
    key: "getStaticPosition",
    value: function getStaticPosition() {
      return this.getContentBox();
    }
  }, {
    key: "getViewportOffsetX",
    value: function getViewportOffsetX() {
      var _this$window$visualVi;
      if (this.IsDeviceIOS() && (_this$window$visualVi = this.window.visualViewport) !== null && _this$window$visualVi !== void 0 && _this$window$visualVi.offsetLeft) {
        return this.window.visualViewport.offsetLeft;
      } else {
        return 0;
      }
    }
  }, {
    key: "getViewportOffsetY",
    value: function getViewportOffsetY() {
      var _this$window$visualVi2;
      if (this.IsDeviceIOS() && (_this$window$visualVi2 = this.window.visualViewport) !== null && _this$window$visualVi2 !== void 0 && _this$window$visualVi2.offsetTop) {
        return this.window.visualViewport.offsetTop;
      } else {
        return 0;
      }
    }

    /**
     * set positioning to right of target
     * @returns {{x: *, y: *}}
     */
  }, {
    key: "getRightPosition",
    value: function getRightPosition() {
      var target = this.target.position;
      var content = this.content.position;
      var x = 0,
        y = 0;
      if (target.x) x = target.x - this.offsetParent.x + target.width + 10 + this.getViewportOffsetX();
      if (target.y) y = target.y - this.offsetParent.y + target.height / 2 - content.height / 2 + this.getViewportOffsetY();
      return {
        x: x,
        y: y
      };
    }

    /**
     * set positioning to bottom of target
     * @returns {{x: *, y: *}}
     */
  }, {
    key: "getBottomPosition",
    value: function getBottomPosition() {
      var target = this.target.position;
      var content = this.content.position;
      var x = 0,
        y = 0;
      if (target.x) x = target.x - this.offsetParent.x + target.width / 2 - content.width / 2 + this.getViewportOffsetX();
      if (target.y) y = target.y - this.offsetParent.y + target.height + 10 + this.getViewportOffsetY();
      return {
        x: x,
        y: y
      };
    }

    /**
     * set positioning to bottom right of the target
     * @returns {{x: number, y: number}}
     */
  }, {
    key: "getBottomRightPosition",
    value: function getBottomRightPosition() {
      var target = this.target.position;
      var content = this.content.position;
      var x = 0,
        y = 0;
      if (target.x) x = target.x - this.offsetParent.x + target.width - content.width + this.getViewportOffsetX();
      if (target.y) y = target.y - this.offsetParent.y + target.height + 10 + this.getViewportOffsetY();
      return {
        x: x,
        y: y
      };
    }

    /**
     * set positioning to left of target
     * @returns {{x: *, y: *}}
     */
  }, {
    key: "getLeftPosition",
    value: function getLeftPosition() {
      var target = this.target.position;
      var content = this.content.position;
      var x = 0,
        y = 0;
      if (target.x) x = target.x - this.offsetParent.x - content.width - 10 + this.getViewportOffsetX();
      if (target.y) y = target.y - this.offsetParent.y + target.height / 2 - content.height / 2 + this.getViewportOffsetY();
      return {
        x: x,
        y: y
      };
    }

    /**
     * set positioning to top of target
     * @returns {{x: *, y: *}}
     */
  }, {
    key: "getTopPosition",
    value: function getTopPosition() {
      var target = this.target.position;
      var content = this.content.position;
      var x = 0,
        y = 0;
      if (target.x) x = target.x - this.offsetParent.x + target.width / 2 - content.width / 2 + this.getViewportOffsetX();
      if (target.y) y = target.y - this.offsetParent.y - content.height - 10 + this.getViewportOffsetY();
      return {
        x: x,
        y: y
      };
    }

    /**
     * set positioning to top left of target
     * @returns {{x: number, y: number}}
     */
  }, {
    key: "getTopLeftPosition",
    value: function getTopLeftPosition() {
      var target = this.target.position;
      var content = this.content.position;
      var x = target.x - this.offsetParent.x + this.getViewportOffsetX(),
        y = 0;
      if (target.y) y = target.y - this.offsetParent.y - content.height - 10 + this.getViewportOffsetY();
      return {
        x: x,
        y: y
      };
    }
  }, {
    key: "getRelativePosition",
    value: function getRelativePosition() {
      this.getContentBox();
      this.getTargetBox();
      switch (this.relativePosition) {
        case "Right":
          return this.getRightPosition();
        case "Bottom":
          return this.getBottomPosition();
        case "BottomRight":
          return this.getBottomRightPosition();
        case "Left":
          return this.getLeftPosition();
        case "Top":
          return this.getTopPosition();
        case "TopLeft":
          return this.getTopLeftPosition();
        default:
          return {
            x: 0,
            y: 0
          };
      }
    }
  }, {
    key: "getFixedPosition",
    value: function getFixedPosition() {
      var values = this.getRelativePosition();
      if (this.offsetParent && typeof this.offsetParent.x !== "undefined") {
        values.x += this.offsetParent.x;
      }
      if (this.offsetParent && typeof this.offsetParent.y !== "undefined") {
        values.y += this.offsetParent.y;
      }
      return values;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      switch (this.type) {
        case "static":
          return this.getStaticPosition();
        case "relative":
          return this.getRelativePosition();
        case "fixed":
          return this.getFixedPosition();
        default:
          return null;
      }
    }
  }]);
}();